import EmbeddedBoard from "segments/desktop/core-components/embedded-board/embedded-board";
import ViewsTabContentComponent from "components/core/live-board-experience/tabs-content/views-tab-content/views-tab-component";
import IntegrationsTabContentComponent from "components/core/live-board-experience/tabs-content/integrations-tab-content/integrations-tab-component";
import AutomationsTabContentComponent from "components/core/live-board-experience/tabs-content/automations-tab-content/automations-tab-component";
import InviteTabContentComponent from "components/core/live-board-experience/tabs-content/invite-tab-content/invite-tab-component";
import NotificationsTabContentComponent from "components/core/live-board-experience/tabs-content/notifications-tab-content/notifications-tab-component";

export const tabs = [
  {
    tabLabel: "Main table",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_home.svg"
    },
    tabComponent: function () {
      return (
        <EmbeddedBoard
          hideTopFrame={true}
          tooltipText={null}
          sharableLink={"https://view.monday.com/3565981122-91f9221ceff3c454e3b37cbc72ea5d33?r=use1"}
        />
      );
    }
  },
  {
    tabLabel: "Views",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_views.svg"
    },
    tabComponent: function () {
      return <ViewsTabContentComponent />;
    }
  },
  {
    tabLabel: "Integrations",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_integrations.svg"
    },
    tabComponent: function () {
      return <IntegrationsTabContentComponent />;
    }
  },
  {
    tabLabel: "Automations",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_automations.svg"
    },
    tabComponent: function () {
      return <AutomationsTabContentComponent />;
    }
  },
  {
    tabLabel: "Invite",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_invite.svg"
    },
    tabComponent: function () {
      return <InviteTabContentComponent />;
    }
  },
  {
    tabLabel: "",
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_notifications.svg"
    },
    tabComponent: function () {
      return <NotificationsTabContentComponent />;
    }
  }
];

export const LIVE_BOARD_VW_WIDTH = 90;
export const LEFT_PANNEL_VW_WIDTH = 4;
export const RIGHT_SECTION_VW_WIDTH = LIVE_BOARD_VW_WIDTH - LEFT_PANNEL_VW_WIDTH;
export const RIGHT_SECTION_RIGHT_VW_MARGIN = 2;
export const BANNER_SIDE_VW_MARGIN = 2;
export const BANNER_VW_WIDTH = LIVE_BOARD_VW_WIDTH - LEFT_PANNEL_VW_WIDTH - 2 * BANNER_SIDE_VW_MARGIN;
